import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { IN_PROGRESS_STATUS, InsuranceVerificationStatus } from '@/types/insuranceVerification';
import { Pill, type PillProps } from '@/ui';

import './styles.css';
import type { Props } from './types';

export const NOT_APPLICABLE_STATUS = 'Not applicable';

const STATUS_STYLES: Record<string, Pick<PillProps, 'color' | 'variant'>> = {
  [InsuranceVerificationStatus.VERIFIED]: { color: 'primary' },
  [InsuranceVerificationStatus.BILLING_REQUIREMENTS_MET]: { color: 'secondary' },
  [InsuranceVerificationStatus.PENDING]: { color: 'neutral' },
  [InsuranceVerificationStatus.PENDING_COB]: { color: 'warning' },
  [InsuranceVerificationStatus.FAILED]: { color: 'destructive' },
  [IN_PROGRESS_STATUS]: { color: 'secondary' },
  [NOT_APPLICABLE_STATUS]: { color: 'neutral', variant: 'outline' }
};

const VerificationStatusPill = ({ status, isSelfPay = false, className }: Props) => {
  const resolvedStatus = isSelfPay
    ? NOT_APPLICABLE_STATUS
    : status || InsuranceVerificationStatus.PENDING;
  const { color, variant } = STATUS_STYLES[resolvedStatus] ?? { color: 'neutral' as const };

  return (
    <Pill color={color} variant={variant ?? 'subtle'} size="sm" className={className}>
      {resolvedStatus === IN_PROGRESS_STATUS && (
        <FontAwesomeIcon icon={faSpinner} spin className="h-3 w-3" />
      )}
      {resolvedStatus}
    </Pill>
  );
};

export default React.memo(VerificationStatusPill);
